var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    fill: "#937249"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.000000) translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#e1f1ff",
    fillOpacity: 0.501961,
    points: "19,12 214,177 136,229"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dee7f8",
    fillOpacity: 0.501961,
    points: "160,105 105,21 32,84"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#682c00",
    fillOpacity: 0.501961,
    points: "271,-3 250,103 27,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4f1e00",
    fillOpacity: 0.501961,
    points: "271,258 101,257 271,139"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3f1606",
    fillOpacity: 0.501961,
    points: "271,132 213,183 167,111"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6d3e00",
    fillOpacity: 0.501961,
    points: "-8,184 -3,255 231,254"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecae54",
    fillOpacity: 0.501961,
    points: "68,156 -16,189 -16,1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#091e2c",
    fillOpacity: 0.501961,
    points: "46,108 128,236 109,165"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d2d3d3",
    fillOpacity: 0.501961,
    points: "72,131 115,38 123,209"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a1610c",
    fillOpacity: 0.501961,
    points: "136,6 120,82 271,97"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9f650d",
    fillOpacity: 0.501961,
    points: "122,10 -16,-9 40,64"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#764024",
    fillOpacity: 0.501961,
    points: "217,127 108,103 119,136"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#060000",
    fillOpacity: 0.501961,
    points: "96,183 101,163 132,157"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "32,92 26,60 60,116"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3a1e00",
    fillOpacity: 0.501961,
    points: "253,-16 79,-5 271,40"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cccaca",
    fillOpacity: 0.501961,
    points: "108,22 32,69 104,152"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d1d4de",
    fillOpacity: 0.501961,
    points: "174,124 206,183 133,232"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "176,128 208,146 210,179"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1a161c",
    fillOpacity: 0.501961,
    points: "136,61 121,73 176,103"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6a1700",
    fillOpacity: 0.501961,
    points: "96,62 101,71 72,88"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43423e",
    fillOpacity: 0.501961,
    points: "139,175 169,167 119,157"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#efa979",
    fillOpacity: 0.501961,
    points: "164,105 204,89 270,113"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d29942",
    fillOpacity: 0.501961,
    points: "0,83 0,16 85,27"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00000b",
    fillOpacity: 0.501961,
    points: "68,40 28,65 52,59"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "118,225 105,188 146,241"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ae742a",
    fillOpacity: 0.501961,
    points: "-12,191 142,256 52,125"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d7c3b4",
    fillOpacity: 0.501961,
    points: "158,101 143,78 109,136"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000404",
    fillOpacity: 0.501961,
    points: "61,108 76,152 36,94"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "170,219 141,228 189,197"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6f3b22",
    fillOpacity: 0.501961,
    points: "144,107 151,142 213,114"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9a6319",
    fillOpacity: 0.501961,
    points: "190,244 271,149 115,255"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#101514",
    fillOpacity: 0.501961,
    points: "114,17 62,48 81,24"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1c1918",
    fillOpacity: 0.501961,
    points: "182,162 183,171 198,161"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dae0e3",
    fillOpacity: 0.501961,
    points: "104,178 141,174 135,227"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d7dfe3",
    fillOpacity: 0.501961,
    points: "152,175 109,131 153,144"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b37623",
    fillOpacity: 0.501961,
    points: "107,14 225,56 156,87"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#210000",
    fillOpacity: 0.501961,
    points: "190,96 154,89 159,103"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "218,175 173,209 208,196"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cac4c1",
    fillOpacity: 0.501961,
    points: "112,44 58,107 31,68"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "133,196 142,199 145,192"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "159,159 150,159 157,172"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4d300c",
    fillOpacity: 0.501961,
    points: "-3,215 97,269 -16,270"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "111,191 71,135 83,168"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dae0e3",
    fillOpacity: 0.501961,
    points: "135,64 83,62 106,23"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8d5b36",
    fillOpacity: 0.501961,
    points: "271,126 179,102 229,184"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00070a",
    fillOpacity: 0.501961,
    points: "133,47 136,64 112,30"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "180,130 209,148 217,188"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b27d33",
    fillOpacity: 0.501961,
    points: "55,48 104,16 -16,13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000002",
    fillOpacity: 0.501961,
    points: "21,71 51,101 31,66"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dededc",
    fillOpacity: 0.501961,
    points: "136,152 71,127 88,154"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6b4000",
    fillOpacity: 0.501961,
    points: "271,166 174,245 263,259"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3f1c00",
    fillOpacity: 0.501961,
    points: "71,105 59,100 53,116"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#381b05",
    fillOpacity: 0.501961,
    points: "128,88 151,74 120,77"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdc7c5",
    fillOpacity: 0.501961,
    points: "177,129 207,175 167,142"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000005",
    fillOpacity: 0.501961,
    points: "133,240 161,223 130,232"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#411d00",
    fillOpacity: 0.501961,
    points: "117,169 94,154 105,171"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#080000",
    fillOpacity: 0.501961,
    points: "142,167 131,160 139,176"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7f4f0b",
    fillOpacity: 0.501961,
    points: "271,33 271,93 80,-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d9642c",
    fillOpacity: 0.501961,
    points: "72,79 93,67 83,83"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d9dbd9",
    fillOpacity: 0.501961,
    points: "123,208 127,147 142,222"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#512d19",
    fillOpacity: 0.501961,
    points: "153,118 120,134 173,130"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dee0dd",
    fillOpacity: 0.501961,
    points: "117,63 55,101 123,101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b3b8b9",
    fillOpacity: 0.501961,
    points: "60,51 57,106 32,70"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d9d8d7",
    fillOpacity: 0.501961,
    points: "137,230 181,196 167,153"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#371e00",
    fillOpacity: 0.501961,
    points: "271,-1 248,22 164,-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#787e7a",
    fillOpacity: 0.501961,
    points: "88,50 68,54 51,72"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ac6f22",
    fillOpacity: 0.501961,
    points: "106,11 152,82 160,27"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#280300",
    fillOpacity: 0.501961,
    points: "96,64 102,70 92,75"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c29f83",
    fillOpacity: 0.501961,
    points: "123,78 131,126 152,105"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363234",
    fillOpacity: 0.501961,
    points: "197,169 191,171 198,178"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8f8678",
    fillOpacity: 0.501961,
    points: "130,173 112,183 120,189"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c89363",
    fillOpacity: 0.501961,
    points: "177,86 270,106 222,123"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c5c9c6",
    fillOpacity: 0.501961,
    points: "143,182 156,150 142,130"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#794f1f",
    fillOpacity: 0.501961,
    points: "49,271 153,271 111,208"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0c0000",
    fillOpacity: 0.501961,
    points: "123,104 122,109 131,112"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c36c2c",
    fillOpacity: 0.501961,
    points: "123,56 136,69 134,78"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#040701",
    fillOpacity: 0.501961,
    points: "121,208 85,153 95,186"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a06721",
    fillOpacity: 0.501961,
    points: "193,222 219,184 143,237"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ad6f4b",
    fillOpacity: 0.501961,
    points: "215,172 241,167 213,146"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000002",
    fillOpacity: 0.501961,
    points: "33,61 51,55 26,72"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c49655",
    fillOpacity: 0.501961,
    points: "68,150 -7,23 13,183"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1f1904",
    fillOpacity: 0.501961,
    points: "129,162 121,158 101,171"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cfd1d1",
    fillOpacity: 0.501961,
    points: "131,160 159,129 112,142"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1b0c02",
    fillOpacity: 0.501961,
    points: "152,158 152,166 166,174"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a1653d",
    fillOpacity: 0.501961,
    points: "204,142 174,101 138,103"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c08c41",
    fillOpacity: 0.501961,
    points: "-16,29 28,65 89,25"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#905a18",
    fillOpacity: 0.501961,
    points: "249,102 271,61 180,83"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#654023",
    fillOpacity: 0.501961,
    points: "215,132 271,182 271,113"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000715",
    fillOpacity: 0.501961,
    points: "110,19 120,37 100,17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#351403",
    fillOpacity: 0.501961,
    points: "74,112 74,122 61,135"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "72,46 68,47 73,50"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c5c0b8",
    fillOpacity: 0.501961,
    points: "86,151 139,112 70,128"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c69472",
    fillOpacity: 0.501961,
    points: "72,101 78,118 63,121"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c9b7ac",
    fillOpacity: 0.501961,
    points: "164,133 192,154 163,177"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000008",
    fillOpacity: 0.501961,
    points: "129,238 140,238 121,209"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#996a30",
    fillOpacity: 0.501961,
    points: "64,244 -16,159 113,216"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00030a",
    fillOpacity: 0.501961,
    points: "139,66 138,77 152,82"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e3e5ea",
    fillOpacity: 0.501961,
    points: "136,230 136,203 147,199"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#090000",
    fillOpacity: 0.501961,
    points: "135,158 135,165 143,172"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2e4b32",
    fillOpacity: 0.501961,
    points: "117,120 118,109 113,106"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLow);
export default __webpack_public_path__ + "static/media/instagram_low.021fe592b9de28449c80180a51cf9e25.svg";
export { ForwardRef as ReactComponent };